/**
 * How wide a tree's frame is (#78, Jason, 2026-10-22: "widen the screen to fit more on a single view"): on a window
 * wider than the page's working width (`.shell`), out past the shell's edges to the window's, less a 16px gutter each
 * side; but only out of an edge its column shares with the shell, so it never runs over a column beside it (Settings'
 * list of sections). On a narrower window, the column as it is, the board scrolling across in it as before.
 */

export const FRAME_GUTTER = 16;

export interface Span {
  left: number;
  right: number;
}

/** The frame's left edge and width, in the window's pixels, from its column's, the shell's content and the window's. */
export function frameSpan(column: Span, shell: Span | null, windowWidth: number, gutter = FRAME_GUTTER): { left: number; width: number } {
  const same = (a: number, b: number) => Math.abs(a - b) < 2;
  const left = shell && same(column.left, shell.left) ? Math.min(column.left, gutter) : column.left;
  const right = shell && same(column.right, shell.right) ? Math.max(column.right, windowWidth - gutter) : column.right;
  return { left, width: Math.max(0, right - left) };
}
